/** Para ve tarih gösterimi: API tutarları kuruş cinsinden metin ("2500") + para birimi; saat dilimi Malta */
export interface Money {
  amountMinor: string;
  currency: string;
}

const TZ = "Europe/Malta";
const LOCALE = "tr-TR";

export function money(m: Money | null | undefined): string {
  if (!m) return "—";
  const minor = BigInt(m.amountMinor);
  const neg = minor < 0n;
  const abs = neg ? -minor : minor;
  // kuruşu sayıya güvenle çevir (tutarlar < 2^53)
  const value = Number(abs) / 100;
  const s = new Intl.NumberFormat(LOCALE, { style: "currency", currency: m.currency }).format(
    value,
  );
  return neg ? `−${s}` : s;
}

export function minor(amountMinor: string | number | bigint | null | undefined, currency = "EUR") {
  if (amountMinor === null || amountMinor === undefined) return "—";
  return money({ amountMinor: String(amountMinor), currency });
}

export function dateTime(v: string | Date | null | undefined): string {
  if (!v) return "—";
  return new Intl.DateTimeFormat(LOCALE, {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: TZ,
  }).format(new Date(v));
}

export function date(v: string | Date | null | undefined): string {
  if (!v) return "—";
  return new Intl.DateTimeFormat(LOCALE, { dateStyle: "medium", timeZone: TZ }).format(new Date(v));
}

/** "3 sa önce" gibi göreli zaman (kuyruklarda bekleme süresi) */
export function ago(v: string | Date | null | undefined, now = Date.now()): string {
  if (!v) return "—";
  const s = Math.round((now - new Date(v).getTime()) / 1000);
  const rtf = new Intl.RelativeTimeFormat(LOCALE, { numeric: "auto" });
  if (Math.abs(s) < 60) return rtf.format(-s, "second");
  if (Math.abs(s) < 3600) return rtf.format(-Math.round(s / 60), "minute");
  if (Math.abs(s) < 86400) return rtf.format(-Math.round(s / 3600), "hour");
  return rtf.format(-Math.round(s / 86400), "day");
}

export const shortId = (id: string | null | undefined) => (id ? id.slice(0, 8) : "—");
